/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * Angular 17 targets evergreen browsers only — no IE polyfills needed.
 */
import '@angular/localize/init';

/** Zone JS is required by Angular itself. */
import 'zone.js';

// Some older npm packages expect Node.js 'global' to exist in the browser.
(window as any).global = window;
